/**
 * Datos de credibilidad: estadísticas, logos de clientes y testimonios.
 * Los componentes correspondientes (StatsBar, ClientLogos, Testimonials) sólo
 * renderizan lo que tenga datos: un array vacío no muestra la sección.
 *
 * REGLAS:
 *  - No inventar cifras. `value: null` = pendiente de confirmar; no se renderiza.
 *  - Sólo se publican logos de clientes con autorización por escrito (`permission: true`).
 *  - Un testimonio sin nombre y cargo reales no se publica.
 */

/**
 * ÚNICA fuente de cifras de la portada (las muestra <StatsBar> bajo el hero).
 * El contador antiguo de la sección "Nosotros" (38 proyectos / 12 empresas locales /
 * 5 internacionales / 15 años) se retiró para no mostrar dos bloques de números.
 * Para publicar una cifra: cambia `value: null` por el texto a mostrar ('38', '40+', '17'…).
 */
export const STATS = [
    { value: '15+', label: 'años desarrollando software' },
    { value: '5', label: 'empresas certificadas como emisores electrónicos ante la DGII por nosotros' },
    { value: '40+', label: 'proyectos entregados' }, // TODO: confirmar (el contador antiguo decía 38 "proyectos realizados")
    { value: 10, label: 'clientes activos' }, // TODO: confirmar (el contador antiguo decía 12 empresas locales + 5 internacionales)
];

/**
 * Clientes con logo. Se muestran en el slider <ClientLogos> de la portada y en la
 * sección "Empresas que confían en nosotros" de /facturacion-electronica (misma fuente).
 *
 * Cómo añadir un cliente:
 *  1. Guarda el logo en public/assets/custom/images/clients/<nombre>.png
 *     (PNG o SVG con fondo transparente, ~400×160 px máx.; se muestra en gris y a color al pasar el ratón).
 *  2. Añade una línea aquí con `permission: true` SÓLO si el cliente autorizó por escrito mostrar su logo.
 *  3. `npm run build` y subir. Sin `permission: true` el logo no se renderiza.
 *  `url` es opcional (enlace al sitio del cliente); `sector` es opcional (texto para el título del logo).
 */
export const CLIENTS = [
    // Publicados ya en la landing de facturación electrónica antes del 18-ago-2026. TODO (Alan): confirmar autorización escrita.
    { name: 'American Paper SRL', logo: '/assets/custom/images/clients/american-paper.png', url: null, sector: 'Distribución', permission: true },
    { name: 'PM Beauty Studio', logo: '/assets/custom/images/clients/pm-beauty-studio.jpg', url: null, sector: 'Belleza', permission: true },
    { name: 'Pekrys', logo: '/assets/custom/images/clients/pekrys.jpg', url: null, sector: 'Restaurante', permission: true },
    { name: 'Soluciones Térmicas Dominicana', logo: '/assets/custom/images/clients/soluciones-termicas-dom.png', url: null, sector: 'Industria', permission: true },
    { name: 'AGG Colors', logo: '/assets/custom/images/clients/agg-colors_logo.png', url: null, sector: 'Pinturas', permission: true },
    { name: 'P&P Consulteam', logo: '/assets/custom/images/clients/pyp-consulteam.png', url: null, sector: 'Construcción', permission: true },
    // Ejemplo para los siguientes:
    // { name: 'Nombre del cliente', logo: '/assets/custom/images/clients/cliente.png', url: 'https://www.cliente.com', sector: 'Retail', permission: true },
];

/**
 * Testimonios. Formato:
 * { quote: '…', author: 'Nombre Apellido', role: 'Gerente General', company: 'Empresa S.R.L.',
 *   logo: '/assets/custom/images/clients/empresa.png', videoUrl: null }
 * `videoUrl` (opcional): URL de YouTube/Vimeo del testimonio en video.
 */
export const TESTIMONIALS = [
    // TODO (Alan): agregar testimonios reales con nombre y cargo. Ejemplo:
    // { quote: 'Texto del testimonio.', author: 'Nombre Apellido', role: 'Cargo', company: 'Empresa', logo: null, videoUrl: null },
];

/** Texto exacto del badge de certificación (no usar el logo de la DGII). */
export const CERTIFIED_BADGE_TEXT = 'Emisor Electrónico certificado ante la DGII';
